<template>
  <div>
    <!-- <img src="../../static/images/Decs_banner2.png" alt="" class="DescLogo2"> -->
    <div class="container" style="background:#fff;width:100%">
      <h2 class="text-center p-4">高速钢圆锯片参数</h2>

      <!-- <div class="p-4">
        <b-carousel
            id="carousel-fade"
            style="text-shadow: 0px 0px 2px #000;"
            fade
            indicators
            :interval="4000"
            controls
            img-width="1024"
            
            
        >
            <b-carousel-slide
            v-for="(items,index) in swiperImg" :key="index"
            :caption=items.txt
            :img-src=items.src
            style="max-height:618px"
            ></b-carousel-slide>
            
        </b-carousel>
        </div> -->

      <div class="ParamsPic">
        <b-row v-for="(item, index) in mainImg" :key="index">
          <b-col class="borderline">
            <b-img :src="item.src" style="width:100%"> </b-img>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mainImg: [
        { src: require("../../../static/Updatedimg/HSSstandard.jpg") },
        { src: require("../../../static/Updatedimg/HSSstandard-2.jpg") },
        { src: require("../../../static/Updatedimg/HSSstandard-3.jpg") },
        { src: require("../../../static/Updatedimg/HSSstandard-4.jpg") },
      ],

      // 视频播放
    };
  },
};
</script>

<style scoped>
.DescLogo {
  visibility: hidden;
  animation: bottom-top 1s linear forwards;
  padding-right: 30px;
  width: 50%;
}
.DescLogo2 {
  width: 100%;
}
.Desc_main {
  font-size: 16px;
  padding-top: 20px;
  padding-bottom: 30px;
}
.borderline {
  border: 3px outset #5676a9;
}
.ParamsPic .row {
  padding-bottom: 10px;
}
</style>
